import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[ruleDetailDirective]',
})
export class RuleDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}